import { render } from "./Fireworks.vue?vue&type=template&id=38e7883e&scoped=true&bindings={}"
import script from "./Fireworks.vue?vue&type=script&lang=js"
export * from "./Fireworks.vue?vue&type=script&lang=js"

import "./Fireworks.vue?vue&type=style&index=0&id=38e7883e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38e7883e"

export default script